module.exports = __webpack_public_path__ + "img/bullet_12.01608f17.svg";